import React, {Component, useState} from 'react';
import axios from "axios";
import config from 'react-global-configuration';
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Select from 'react-select';
import Switch from 'react-switch';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import AsyncPaginate from 'react-select-async-paginate';
import moment from 'moment';
import loadOptions from './loadOptions';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const defaultAdditional = {
    page: 1
};
  
const loadPageOptions = async (q, prevOptions, { page }) => {
    const { options, hasMore } = await loadOptions(q, page);
    return {
        options,
        hasMore,
        additional: {
            page: page + 1
        }
    };
};

//const [valuera, onChangea] = useState(null);


class Campaign extends Component{
    constructor(props) {
        super(props);
        this.state = {
            activer: {
                '0': true, 
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            isEMI: {
                '0': false, 
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            isUpfront: {
                '0': false,
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            zeroCost: {
                '0': false, 
                '1': false,
                '2': false,
                '3': false,
                '4': false,
                '5': false,
                '6': false,
                '7': false,
                '8': false,
                '9': false,
                '10': false,
                '11': false
            },
            _notificationSystem: null,
            mapField: false,
            bank_name_list: ["AMEX BANK", "AXIS BANK", "CITIBANK", "HDFC Bank", "HSBC Bank", "ICICI Bank", "INDUSIND BANK", "KOTAK BANK", "RBL BANK", "SBI CARD", "STANDARD CHARTERED BANK", "YES BANK"],
            tenure_list: {
                '0': true, 
                '1': true,
                '2': true,
                '3': true
                },
            bankOptions: [
                { name: 'AMEX', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Axis', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Citi', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HDFC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HSBC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'ICICI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'IndusInd', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Kotak', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'RBL', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SBI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SCB', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'YES', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true}
            ],
            brandSubventionOptions: [
                { value: 'Percent', label: 'Percent' },
                { value: 'Cashback', label: 'Flat Cashback' }
            ],
            bankSubventionOptions: [
                { value: 'NA', label: 'NA'  },
                { value: 'Percent', label: 'Percent' },
                { value: 'Cashback', label: 'Flat Cashback' }
            ],
            merchantSubventionOptions: [
                { value: 'All_Level', label: 'Applicable Everywhere'},
                { value: 'State_Level', label: 'State Level'},
                { value: 'City_Level', label: 'City Level'},
                { value: 'Merchant_Level', label: 'Merchant Level'},
                { value: 'Chain_Level', label: 'Chain Level' },
                { value: 'Store_Level', label: 'Store Level' },
            ],
            maxTxnAmount: 10000,
            selectedBrandSubvention: 'Percent',
            selectedBankSubvention: 'NA',
            selectedMerchantSubvention: 'All_Level',
            selectedState: [],
            selectedCity: [],
            merchant_disabler: true,
            //brand_subvention_list: ['Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent'],
            //bank_subvention_list: ['NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA'],
            brand_subvention_list:{
                '0': 'Percent', 
                '1': 'Percent',
                '2': 'Percent',
                '3': 'Percent',
                '4': 'Percent',
                '5': 'Percent',
                '6': 'Percent',
                '7': 'Percent',
                '8': 'Percent',
                '9': 'Percent',
                '10': 'Percent',
                '11': 'Percent'
            },
            bank_subvention_list: {
                '0': 'NA', 
                '1': 'NA',
                '2': 'NA',
                '3': 'NA',
                '4': 'NA',
                '5': 'NA',
                '6': 'NA',
                '7': 'NA',
                '8': 'NA',
                '9': 'NA',
                '10': 'NA',
                '11': 'NA'
            },
            brand_subvention_value: {
                '0': '10',
                '1': '10',
                '2': '10',
                '3': '10',
                '4': '10',
                '5': '10',
                '6': '10',
                '7': '10',
                '8': '10',
                '9': '10',
                '10': '10',
                '11': '10'
            },
            bank_subvention_value: {
                '0': '0',
                '1': '0',
                '2': '0',
                '3': '0',
                '4': '0',
                '5': '0',
                '6': '0',
                '7': '0',
                '8': '0',
                '9': '0',
                '10': '0',
                '11': '0'
            },
            maximum_cashback: {
                '0': '1000',
                '1': '1000',
                '2': '1000',
                '3': '1000',
                '4': '1000',
                '5': '1000',
                '6': '1000',
                '7': '1000',
                '8': '1000',
                '9': '1000',
                '10': '1000',
                '11': '1000'
            },
            disabler_list: [true, true, true, true, true, true, true, true, true, true, true, true],
            mapField2: false,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            sku_showModel: false,
            sku_list: [],
            raw_display_data: [],
            state_display_data: [],
            city_display_data: [],
            merchant_display_data: [],
            chain_display_data: [],
            store_display_data: [],
            state_data: [
                {value: "NA", label: "NA"}
            ],
            city_data: [
                {value: "NA", label: "NA"}
            ],
            state_loaded: false,
            city_loaded: false,
            sku_monitor: 0,
            selectedMerchValues: [],
            selectedRefineSubvention: [],
            slicedMerchValues: [],
            the_bank_list: {},
            bank_name_list1: {},
            refineSearch: false,
            state_ida: '',
            city_ida: '',
            merchant_ida: '',
            chain_ida: '',
            refinerMerch: [false, false, false, false, false],
            valuera: null,
            mapField3: false,
            mapField0: false,
            //redirect = false
        };
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    changeTenure(index, month, checked) {
        const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
            if (index === bank_index) {
                return {
                    ...bank_value,
                    [month]: checked.target.checked
                };
            }
            return bank_value;
        });
        this.setState({bankOptions, mapField2: false});
    }

    onChangera(){
        console.log("Hello");
    }

    changeValue(index, value, checked) {
        const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
            if (index === bank_index) {
                if(value === 'bank_type' && checked.value === 'NA'){
                    this.setState({
                        disabler_list: {...this.state.disabler_list, [index]:true}
                    });
                    return {
                        ...bank_value,
                        [value]: checked.value,
                        ['bank_value']: 0
                    };
                }
                else if(value === 'bank_type' && checked.value !== 'NA'){
                    this.setState({
                        disabler_list: {...this.state.disabler_list, [index]:false}
                    });
                    return {
                        ...bank_value,
                        [value]: checked.value
                    };
                }
                else{
                    return {
                        ...bank_value,
                        [value]: checked.value
                    };
                }
            }
            return bank_value;
        });
        this.setState({bankOptions});
    }

    retrieveStateData(){
        console.log("retrieving state data");
        axios.get(config.get('API_URL') + '/brandemi/get_state',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const state_data = response.data.map((values, index) =>{
                console.log(values['state_name']);
                return{
                    ['value']: values['state_id'],
                    ['label']: values['state_name']
                };
            });
            this.setState({
                state_data: state_data, 
                mapField2: false,
                state_display_data: response.data,
                loading: false
            });
        });
    }

    retrieveCityData(){
        console.log("retrieving city data");
        axios.get(config.get('API_URL') + '/brandemi/get_city',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const city_data = response.data.map((values, index) =>{
                if (index == 0) {
                    this.setState({selectedCity: values['city_name']});
                }
                console.log(values['city_name']);
                return{
                    ['value']: values['city_id'],
                    ['label']: values['city_name']
                };
            });
            this.setState({city_data: city_data, mapField2: false});
            this.setState({
                city_display_data: response.data
            });
            this.setState({
                loading: false
            });
        });
    }

    componentDidMount(){
        this._refreshSku_Show_View();
        this.setState({ 
            _notificationSystem: this.refs.notificationSystem   
        });
        //var _notificationSystem = this.refs.notificationSystem;
        this.validator = new SimpleReactValidator();
    }

    // componentWillMount(){
    //     this.generateBankList();
    // }

    _refreshSku_Show_View() {
        if ($.fn.DataTable.isDataTable('#sku_showTable')) {
            $('#sku_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/view_csv_data7',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
                file_id: 122
            }
        }).then(response => {
            //console.log(response.data);
            this.setState({
                raw_display_data: response.data
            });
            $('#sku_showTable').DataTable();
            this.setState({
                loading: false
            });
        });
    }

    // generateBankList() {
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_bank_list',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         response.data.map((value, index) => {
    //             if (value.issuer_bank_code != "ISB0000000004" || value.issuer_bank_display_name != "ISB0000000012" || value.issuer_bank_display_name != "XXXXXXXXXXXXX"){
    //                 this.setState({
    //                     bank_name_list1: {...this.state.bank_name_list1, [value.issuer_bank_code]:value.issuer_bank_display_name},
    //                 });
    //             }
    //         });
    //         this.setState({
    //             the_bank_list: response.data,
    //             loading: false
    //         });
    //     });
    // }

        // openSectionToSKU = (status) => {
        //     this.setState({
        //         mapField2: status
        //     })
        // };

    openSectionToBanks = (status) => {
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                mapField2: status
            });
        } 
    }

    openSectionToProduct = (status) => {
        this.setState({
            mapField0: status
        });
    }

    validateDate(){
        if(this.state.startDate > this.state.endDate){
            //console.log("yay");
            this.handleNotificationClick("tr", 3, "Select valid date range");
            console.log("error");
            return 1;
        }
        else{
            return 0;
        }
    }

    validateTenure(){
        let returner = 0;
        let value1 = this.state.bank_name_list.map((value, index) => {
            if (this.state.bankOptions[index]["M3"] === false && this.state.bankOptions[index]["M6"] === false && this.state.bankOptions[index]["M9"] === false && this.state.bankOptions[index]["M12"] === false && this.state.bankOptions[index]["M18"] === false && this.state.bankOptions[index]["M24"] === false && this.state.isEMI[index] == true)
            {
                this.handleNotificationClick("tr", 3, "Select atleast one tenure at bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
        });
        return returner;
            //console.log("yay");
    }

    validateValue(){
        let returner = 0;
        let value1 = this.state.bank_name_list.map((value, index) => {
            if ((this.state.brand_subvention_value[index])*1 < 0 || (this.state.brand_subvention_value[index] === '')){
                this.handleNotificationClick("tr", 3, "Enter positive value at brand subvention value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
            else if ((this.state.bank_subvention_list[index] === 'Percent' || this.state.bank_subvention_list[index] === 'Cashback') && (this.state.bank_subvention_value[index])*1 < 0 || (this.state.bank_subvention_value[index] === ''))
            {
                this.handleNotificationClick("tr", 3, "Enter positive value at bank subvention value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
            else if ((this.state.maximum_cashback[index])*1 < 0 || (this.state.maximum_cashback[index] === ''))
            {
                this.handleNotificationClick("tr", 3, "Enter positive value at maximum cashback value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
        });
         if ((this.state.maxTxnAmount)*1 < 0 || (this.state.maxTxnAmount === '')){
                this.handleNotificationClick("tr", 3, "Enter positive value at maximum cashback allowed per card.");
                console.log("error");
                returner = 1;
        }
        return returner;
    }

    sendEMIMappings(value){
        let value1 = this.validateValue();
        let value2 = this.validateDate();
        let value3 = this.validateTenure();
        console.log(value1);
        console.log(value2);
        console.log(value3);
        if(value1 === 0 && value2 === 0 && value3 === 0 && this.state.sku_monitor > 0){
            //this.openSectionToSKU(value); 
            //this.toggleConfirmationModel();
            // if(this.myRef2.current){
            //     this.myRef2.current.scrollIntoView({ 
            //        behavior: "smooth", 
            //        block: "nearest"
            //     });
            // }
            this.setState({
                mapField3: true
            })
        }
        else{
            this.setState({
                mapField2: false
            });
        }
        
        //else{
        //    this.openSectionToSKU(value);
        //}
    }

    merchantValidator(value) {
        this.setState({
            newConfirmationModel: !this.state.newConfirmationModel
        });

    }

    multiSelectValidator(index){
        if (index === this.state.selectedMerchantSubvention){
            return true;
        }
        else{
            return false;
        }
    }

    refineEnabler(index){
        
    }

    onTurnRefine = (value) => {
        console.log("hi");
        this.setState({
            refineSearch: value
        })
        // if (value == false){
        //     let refinerMerch = [...this.state.refinerMerch];     // create the copy of state array
        //     refinerMerch[0] = false;
        //     refinerMerch[1] = false;
        //     refinerMerch[2] = false;
        //     refinerMerch[3] = false;
        //     refinerMerch[4] = false;
        //     this.setState({
        //         refinerMerch
        //     })
        // }
    }

    updateSKUVisiblity = (value) => {
        this.setState({
            mapField2: value
        })
    };

    updateBrandSubvention = (index, optionSelected) => {
        this.setState({
            brand_subvention_list: {...this.state.brand_subvention_list, [index]:optionSelected.value },
            mapField2: false
        })
    };

    updateState = (optionSelected) => {
        if (optionSelected != null){
            this.setState({
                selectedState: {...this.state.selectedState, [optionSelected.value]: optionSelected.value},
                mapField2: false
            })
        }
        else{
            this.setState({
                selectedState: [],
                mapField2: false
            })
        }
    };


    // _getStateList = async() => {
    //     const options = [];
    //     let res = await axios.get(config.get('API_URL') + "/brandemi/get_state_values", {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     });
        
    //     await res.data.map((str, index) => {
    //         options.push({
    //             value: str.state_id,
    //             label: str.state_name
    //         });
    //     })
    //     console.log(options)
    //     const sleep = ms =>
    //         new Promise(resolve => {
    //             setTimeout(() => {
    //             resolve();
    //             }, ms);
    //         });

    //     const optionsPerPage = 10;

    //     const loadOptions = async (search, page) => {
    //         await sleep(1000);

    //         let filteredOptions;
    //         if (!search) {
    //             filteredOptions = options;
    //         } 
    //         else {
    //             const searchLower = search.toLowerCase();
    //             filteredOptions = options.filter(({ label }) =>
    //             label.toLowerCase().includes(searchLower)
    //             );
    //         }

    //         const hasMore = Math.ceil(filteredOptions.length / optionsPerPage) > page;
    //         const slicedOptions = filteredOptions.slice(
    //             (page - 1) * optionsPerPage,
    //             page * optionsPerPage
    //         );

    //         return {
    //             options: slicedOptions,
    //             hasMore
    //         };
    //     };
    // }

    _getMerchList = async (merch_config, search, loadedOptions, { page } ) => {
        let columna = '';
        let columnb = '';
        let columnc = '';
        if(merch_config === "State_Level"){
            columna = 'state_id';
            columnb = 'state_name';
            columnc = 'state_id';
        }
        if(merch_config === "City_Level"){
            columna = 'city_id';
            columnb = 'city_name';
            columnc = 'city_id';
        }
        if(merch_config === "Merchant_Level"){
            columna = 'merchant_id';
            columnb = 'merchant_name';
            columnc = 'merchant_code';
        }
        if(merch_config === "Chain_Level"){
            columna = 'chain_id';
            columnb = 'chain_name';
            columnc = 'chain_code';
        }
        if(merch_config === "Store_Level"){
            columna = 'store_id';
            columnb = 'store_name';
            columnc = 'store_code';
        }
        this.setState({
            slicedMerchValues: []
        });
        let res = await axios.get(config.get('API_URL') + "/brandemi/get_merch_values/?merch_config="+merch_config+"&search="+search+"&page="+page, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });
        //console.log(res.data);
        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        res.data.map((str, index) => {
            console.log(columna);
            console.log(columnb);
            this.state.slicedMerchValues.push({value: str[columna], label: str[columnb], value1: str[columnc]})
        });
        //console.log(this.state.slicedMerchValues);
        return {
            options: this.state.slicedMerchValues,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    _getRefineList = async (merch_config, search, loadedOptions, { page } ) => {
        console.log(merch_config);
        let columna = '';
        let columnb = '';
        let columnc = '';
        let columnd = '';
        let relevant_id = '$ab';

        if(merch_config === "State_Level"){
            columna = 'state_id';
            columnb = 'state_name';
            columnc = 'state_id';
        }
        if(merch_config === "City_Level"){
            columna = 'city_id';
            columnb = 'city_name';
            columnc = 'city_id';
            relevant_id = this.state.state_ida.value;
        }
        if(merch_config === "Merchant_Level"){
            columna = 'merchant_id';
            columnb = 'merchant_name';
            columnc = 'merchant_code';
            relevant_id = this.state.city_ida.value;
        }
        if(merch_config === "Chain_Level"){
            columna = 'chain_id';
            columnb = 'chain_name';
            columnc = 'chain_code';
            relevant_id = this.state.merchant_ida.value;
        }
        if(merch_config === "Store_Level"){
            columna = 'store_id';
            columnb = 'store_name';
            columnc = 'store_code';
            relevant_id = this.state.chain_ida.value;
        }
        this.setState({
            slicedMerchValues: []
        });
        let res = await axios.get(config.get('API_URL') + "/brandemi/get_refined_values/?merch_config="+merch_config+"&relevant_id="+relevant_id+"&search="+search+"&page="+page, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });
        //console.log(res.data);
        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        res.data.map((str, index) => {
            console.log(columna);
            console.log(columnb);
            this.state.slicedMerchValues.push({value: str[columnc], label: str[columnb], value1: str[columnc]})
        });
        //console.log(this.state.slicedMerchValues);
        return {
            options: this.state.slicedMerchValues,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    updateMerchValues = (optionSelected) => {
        //console.log(optionSelected);
        if (optionSelected === null){
            this.setState({
                selectedMerchValues: [],
                mapField2: false
            });
        }
        else{
            this.setState({
                selectedMerchValues: optionSelected,
                mapField2: false
            });
        }
    };

    updateMerchRefineValues = (optionSelected, valuer) => {
        //console.log(optionSelected);
        //console.log(valuer);
        if (optionSelected === null){
            this.setState({
                selectedMerchValues: [],
                selectedRefineSubvention: [],
                mapField2: false
            });
        }
        else{
            if (optionSelected == 'State_Level')
            {   
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    state_ida: valuer,
                    city_ida: '',
                    merchant_ida: '',
                    chain_ida: '',
                    store_ida: '',
                    mapField2: false
                });
            } 
            else if (optionSelected == 'City_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    city_ida: valuer,
                    merchant_ida: '',
                    chain_ida: '',
                    store_ida: '',
                    mapField2: false
                });
            }
            else if (optionSelected == 'Merchant_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    merchant_ida: valuer,
                    chain_ida: '',
                    store_ida: '',
                    mapField2: false
                });
            } 
            else if (optionSelected == 'Chain_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    chain_ida: valuer,
                    store_ida: '',
                    mapField2: false
                });
            } 
            else if (optionSelected == 'store_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    store_ida: valuer,
                    mapField2: false
                });
            }
        }
    };

    updateCity = (optionSelected) => {
        this.setState({
            selectedCity: optionSelected.value,
            mapField2: false
        })
    };

    updateMerchantSubvention = (optionSelected) => {
        let refinerMerch = [...this.state.refinerMerch];     // create the copy of state array
        refinerMerch[0] = false;
        refinerMerch[1] = false;
        refinerMerch[2] = false;
        refinerMerch[3] = false;
        refinerMerch[4] = false;

        if (optionSelected.value === "All_Level")
        {
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "State_Level")
        {
            refinerMerch[0] = true;
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "City_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;
        
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "Merchant_Level")
        {   
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "Chain_Level")
        {   
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;
            refinerMerch[3] = true;
        

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
                
            });
        }
        else{
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;
            refinerMerch[3] = true;
            refinerMerch[4] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
    };

    updateBankSubvention = (index, optionSelected) => {
        if (optionSelected.value === "NA"){
            this.setState({
                disabler_list: {...this.state.disabler_list, [index]:true}
            });
        }   
        else{
            this.setState({
                disabler_list: {...this.state.disabler_list, [index]:false}
            });
        }
        this.setState({
            bank_subvention_list: {...this.state.bank_subvention_list, [index]:optionSelected.value},
            mapField2: false
        })
    };

    disabler(index){
        this.setState({
            disabler_list: {...this.state.disabler_list, [index]:false}
        });
    }

    handleFromChange = date => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    changeSKU = (sku, checked) => {
        let sku_monitor_incr = this.state. q;
        if (checked === true){
            this.setState((state) => ({
                sku_monitor: state.sku_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                sku_monitor: state.sku_monitor - 1
             }))
        }
        this.setState({
            sku_list: {...this.state.sku_list, [sku]:checked},
            mapField2: false,
            mapField: false
        });
    };

    skuMapping() {
        //console.log("hello world");
    }

    toggleConfirmationModel() { 
        //if (this.state.sku_list.length == 0){
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }
    }

    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };

    sendBankMappings(value) {
        let value1 = 0;
        //console.log(this.state.activer);
        let value2 = this.state.bank_name_list.map((values, index) => {
            if(this.state.activer[index] === true){
                value1 = 1;
            }
        }); 
        if (value1 === 0) {
            this.handleNotificationClick("tr", 3, "Select atleast one bank.");
        }
        else {
            this.openSectionToMap(value);
        }
        if(this.myRef.current){
            this.myRef.current.scrollIntoView({ 
               behavior: "smooth", 
               block: "nearest"
            })
        }
    }

    updateMapVisiblity = (value) => {
        //console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    changeActiver(index, checked) {
        this.setState({
            activer: {...this.state.activer, [index]:checked.target.checked },
            mapField: false

        });
    }

    changeEMIstatus(index, checked) {
        this.setState({
            isEMI: {...this.state.isEMI, [index]:checked.target.checked},
            mapField2: false
        })
    }

    changeZeroCoststatus(index, checked) {
        this.setState({
            zeroCost: {...this.state.zeroCost, [index]:checked.target.checked},
            mapField2: false
        })
    }

    changeisUpfrontstatus(index, checked) {
        this.setState({
            isUpfront: {...this.state.isUpfront, [index]:checked.target.checked},
            mapField2: false
        })
    }

    sendCompleteScheme = () =>{
        this.setState({

        });
        const data = new FormData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(this.state.refineSearch == true){
            data.append('bank_list', JSON.stringify(this.state.bank_name_list));
            data.append('activer', JSON.stringify(this.state.activer));
            data.append('zero_cost', JSON.stringify(this.state.zeroCost));
            data.append('is_emi', JSON.stringify(this.state.isEMI));
            data.append('brand_sub_list', JSON.stringify(this.state.brand_subvention_list));
            data.append('brand_sub_value', JSON.stringify(this.state.brand_subvention_value));
            data.append('tenures', JSON.stringify(this.state.bankOptions));
            data.append('sku_list', JSON.stringify(this.state.sku_list));
            data.append('user_id', decoded._id);
            data.append('start_date', this.state.startDate);
            data.append('end_date', this.state.endDate);
            data.append('max_cashback', this.state.maxTxnAmount);
            data.append('isUpfront', JSON.stringify(this.state.isUpfront));
            data.append('maximum_cashback', JSON.stringify(this.state.maximum_cashback));
            data.append('state_data', JSON.stringify(this.state.state_ida));
            data.append('city_data', JSON.stringify(this.state.city_ida));
            data.append('merchant_data', JSON.stringify(this.state.merchant_ida));
            data.append('chain_data', JSON.stringify(this.state.chain_ida));
            data.append('store_data', JSON.stringify(this.state.store_ida));
            data.append('isRefine', 1);
        }
        else{
            let vary1 = 1008;
            let vary2 = 1008;
            let vary3 = 1008;
            let vary4 = 1008;
            let vary5 = 1008;
            if(this.state.selectedMerchantSubvention == 'State_Level')
            {
                vary1 = this.state.selectedMerchValues.value1;
            }
            else if(this.state.selectedMerchantSubvention == 'City_Level')
            {
                vary2 = this.state.selectedMerchValues.value1;
            }
            else if(this.state.selectedMerchantSubvention == 'Merchant_Level')
            {
                vary3 = this.state.selectedMerchValues.value1;
            }
            else if(this.state.selectedMerchantSubvention == 'Chain_Level')
            {
                vary4 = this.state.selectedMerchValues.value1;
            }
            else if(this.state.selectedMerchantSubvention == 'Store_Level')
            {
                vary5 = this.state.selectedMerchValues.value1;
            }
            data.append('bank_list', JSON.stringify(this.state.bank_name_list));
            data.append('activer', JSON.stringify(this.state.activer));
            data.append('zero_cost', JSON.stringify(this.state.zeroCost));
            data.append('is_emi', JSON.stringify(this.state.isEMI));
            data.append('brand_sub_list', JSON.stringify(this.state.brand_subvention_list));
            data.append('brand_sub_value', JSON.stringify(this.state.brand_subvention_value));
            data.append('tenures', JSON.stringify(this.state.bankOptions));
            data.append('sku_list', JSON.stringify(this.state.sku_list));
            data.append('user_id', decoded._id);
            data.append('start_date', this.state.startDate);
            data.append('end_date', this.state.endDate);
            data.append('max_cashback', this.state.maxTxnAmount);
            data.append('isUpfront', JSON.stringify(this.state.isUpfront));
            data.append('maximum_cashback', JSON.stringify(this.state.maximum_cashback));
            data.append('state_data', vary1);
            data.append('city_data', vary2);
            data.append('merchant_data', vary3);
            data.append('chain_data', vary4);
            data.append('store_data', vary5);
            data.append('isRefine', 0);
        }
        
        axios.post(config.get('API_URL') + '/brandemi/submit_subvention_scheme', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            //console.log(res);
            this.handleNotificationClick("tr", 1, "Data successfully uploaded");
            this.toggleConfirmationModel();
            const yourFunction = async () => {
                await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec
                console.log("Waited 5s");
                this.props.history.push('/')
            };
            yourFunction();

            //this.changeRedirect();
        }).catch(err => {

        })
    };

    whetherDisabled(index){
        if (this.state.brand_subvention_list[index] === "Percent"){
            return false;
            
        }
        else{
            return true;
        }
    }

    render(){

        console.log(this.state.selectedMerchantSubvention);
        //console.log(this.state.sku_list);
        console.log(this.state.selectedMerchValues);
        console.log(this.state.state_ida.value);
        console.log(this.state.city_ida.value);
        console.log(this.state.merchant_ida.value);
        console.log(this.state.chain_ida.value);
        console.log(this.state.refinerMerch);
        
        //console.log(this.state.endDate);

        //const { redirect } = this.state;
        let bank_activer = this.state.activer;
        let start_date = (this.state.startDate); //.toDateString();
        let end_date = (this.state.endDate); //.toDateString();
        let max_txn = this.state.maxTxnAmount;

        let select_view = () =>{
            //console.log(this.state.selectedMerchantSubvention);
            if (this.state.selectedMerchantSubvention === 'State_Level' && this.state.refineSearch == false){
                return(
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select State</Label>
                        <AsyncPaginate name="merchValue"
                            defaultValue={this.state.selectedMerchValues}
                            isClearable={true}
                            onChange={this.updateMerchValues.bind(this)}
                            loadOptions={this._getMerchList.bind(this, this.state.selectedMerchantSubvention)}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select State"
                        />
                    </div>
                );
            }
            else if(this.state.selectedMerchantSubvention === 'City_Level' && this.state.refineSearch == false){
                return(
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select City</Label>
                        <AsyncPaginate name="merchValue"
                            defaultValue={this.state.selectedMerchValues}
                            isClearable={true}
                            onChange={this.updateMerchValues.bind(this)}
                            loadOptions={this._getMerchList.bind(this, this.state.selectedMerchantSubvention)}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select City"
                        />
                    </div>
                );
            }
            else if(this.state.selectedMerchantSubvention === 'Merchant_Level' && this.state.refineSearch == false){
                return(
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select Merchant</Label>
                        <AsyncPaginate name="merchValue"
                            defaultValue={this.state.selectedMerchValues}
                            isClearable={true}
                            onChange={this.updateMerchValues.bind(this)}
                            loadOptions={this._getMerchList.bind(this, this.state.selectedMerchantSubvention)}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select Merchant"
                        />
                    </div>
                );
            }
            else if(this.state.selectedMerchantSubvention === 'Chain_Level' && this.state.refineSearch == false){
                return(
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select Chain</Label>
                        <AsyncPaginate name="merchValue"
                            defaultValue={this.state.selectedMerchValues}
                            isClearable={true}
                            onChange={this.updateMerchValues.bind(this)}
                            loadOptions={this._getMerchList.bind(this, this.state.selectedMerchantSubvention)}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select Chain"
                        />
                    </div>
                );
            }
            else if(this.state.selectedMerchantSubvention === 'Store_Level' && this.state.refineSearch == false){
                return(
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select Store</Label>
                        <AsyncPaginate name="merchValue"
                           defaultValue={this.state.selectedMerchValues}
                           isClearable={true}
                           onChange={this.updateMerchValues.bind(this)}
                           loadOptions={this._getMerchList.bind(this, this.state.selectedMerchantSubvention)}
                           additional={{
                               page: 1,
                           }}
                           placeholder="Select Store"
                        />
                    </div>
                );
            }
            else{
                return(
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Not Applicable</Label>
                        <Input className="form-control-subvention" id={"dummy"} disabled/>
                    </div>
                );
            }
        };

        let sku_selected = this.state.raw_display_data.map((value, index) => {
            if ($.fn.DataTable.isDataTable('#sku_showTable3')) {
                $('#sku_showTable3').DataTable().destroy();
            }
            if (this.state.sku_list[value.sku] === true){
                return (
                <tr key={index + 1} className="trfont">
                    <td className="tdmodal">{index+1}</td>
                    <td className="tdmodal">{value.brand}</td>
                    <td className="tdmodal">{value.category}</td>
                    <td className="tdmodal">{value.level_1}</td>
                    <td className="tdmodal">{value.level_2}</td>
                    <td className="tdmodal">{value.level_3}</td>
                    <td className="tdmodal">{value.level_4}</td>
                    <td className="tdmodal">{value.sku}</td>
                    <td className="tdmodal">{value.product_code}</td>
                    <td className="tdmodal">{value.mrp}</td>
                    <td className="tdmodal">{value.mop}</td>
                </tr>
                );
            }
            $('#sku_showTable3').DataTable();
        });

        let subvention_data = this.state.bank_name_list.map((value, index) => {
            let vala = '';
            if (this.state.brand_subvention_list[index] === 'Percent'){
                vala = this.state.maximum_cashback[index];
            }
            else{
                vala = 'NA';
            }
            if(bank_activer[index] === true)
            {
                if(this.state.isEMI[index] === true)
                {
                    return(
                        <tr key= {index + " " + this.state.bank_name_list[index]}>
                            <td className="tdmodal">{index+1}</td>
                            <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                            <td className="tdmodal">Yes</td>
                            <td className="tdmodal">{this.state.zeroCost[index]? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M3']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M6']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M9']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M12']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M18']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M24']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.brand_subvention_list[index] + ": " + this.state.brand_subvention_value[index]}</td>
                            <td className="tdmodal">{vala}</td>
                        </tr>
                    );
                }
                else{
                    return(
                        <tr key= {index + " " + this.state.bank_name_list[index]}>
                            <td className="tdmodal">{index+1}</td>
                            <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                            <td className="tdmodal">No</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">{this.state.brand_subvention_list[index] + ": " + this.state.brand_subvention_value[index]}</td>
                            <td className="tdmodal">{vala}</td>
                            {/* <td className="tdmodal">NA</td> */}
                        </tr>
                    );
                }
            }
            else{
                return(
                    <tr key= {index + " " + this.state.bank_name_list[index]}>
                        <td className="tdmodal">{index+1}</td>
                        <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                    </tr>
                );
            }
        });
        
        let sku_show_data = this.state.raw_display_data.map((value,index) => {
            return (
                <tr key={index + 1}>
                <td>{index+1}</td>
                <td>{value.brand}</td>
                <td>{value.category}</td>
                <td>{value.level_1}</td>
                <td>{value.level_2}</td>
                <td>{value.level_3}</td>
                <td>{value.level_4}</td>
                <td>{value.sku}</td>
                <td>{value.product_code}</td>
                <td>{value.mrp}</td>
                <td>{value.mop}</td>
                <td>
                    <Switch className="react-switch"
                        height={20} width={38} 
                        id={index + "_"}
                        onColor="#484b9a"
                        onChange={this.changeSKU.bind(this, value.sku)} 
                        checked={(this.state.sku_list[value.sku])? true : false}
                    />
                </td>
            </tr>
            );
        });
        
        
        let refine_search = () => {
            return(
                <div className="row bottompaddingsubvention">
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select Merchant</Label>
                        <AsyncPaginate name="refineValueMerchant"
                            defaultValue={this.state.selectedMerchValues}
                            onChange={this.updateMerchRefineValues.bind(this, "Merchant_Level")}
                            isDisabled={!(this.state.refinerMerch[2] && this.state.refineSearch)}
                            loadOptions={this._getRefineList.bind(this, "Merchant_Level")}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select Merchant"
                            isClearable={true}
                        />
                    </div>
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select Chain</Label>
                        <AsyncPaginate name="refineValueChain"
                            defaultValue={this.state.selectedMerchValues}
                            isDisabled={!(this.state.refinerMerch[3] && this.state.refineSearch)}
                            onChange={this.updateMerchRefineValues.bind(this, "Chain_Level")}
                            loadOptions={this._getRefineList.bind(this, "Chain_Level")}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select Chain"
                            isClearable={true}
                        />
                    </div>
                    <div className=" col-sm-6 col-md-3 col-xs-12">
                        <Label>Select Store</Label>
                        <AsyncPaginate name="refineValueStore"
                            defaultValue={this.state.selectedMerchValues}
                            isDisabled={!(this.state.refinerMerch[4] && this.state.refineSearch)}
                            onChange={this.updateMerchRefineValues.bind(this, "Store_Level")}
                            loadOptions={this._getRefineList.bind(this, "Store_Level")}
                            additional={{
                                page: 1,
                            }}
                            placeholder="Select Store"
                            isClearable={true}
                        />
                    </div>
                </div>
            );
        }

        let bank_names = this.state.bank_name_list.map((value,index) => {
            //console.log(this.state.isEMI[index]);
            let valuera = false;
            if (this.state.brand_subvention_list[index] === "Percent"){
                valuera = false;
            }
            else{
                valuera = true;
            }
            if (bank_activer[index] === true){
               // if ( this.state.isEMI[index] === true)
            
                return <div className="col-md-3 col-sm-6 col-xs-12 " key={index}>       
                    <div className="card p-5">
                    <h5>{this.state.bank_name_list[index]}</h5>
                    <Checkbox number={index + " " + value} label="EMI Scheme Applicable?" onChange={this.changeEMIstatus.bind(this, index)} checked={!!this.state.isEMI[index]}/>
                    <Checkbox  number={"zero_cost_" + index}  label="Zero Cost EMI?" onChange={this.changeZeroCoststatus.bind(this, index)} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.zeroCost[index])} />
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <Checkbox className="checkboxmargin" number={"3_months_" + index}  label="3 months" onChange={this.changeTenure.bind(this, index, 'M3')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M3'])} />
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <Checkbox className="checkboxmargin" number={"6_months_" + index}  label="6 months" onChange={this.changeTenure.bind(this, index, 'M6')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M6'])} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <Checkbox className="checkboxmargin" number={"9_months_" + index}  label="9 months" onChange={this.changeTenure.bind(this, index, 'M9')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M9'])} />
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <Checkbox className="checkboxmargin" number={"12_months_" + index}  label="12 months" onChange={this.changeTenure.bind(this, index, 'M12')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M12'])} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <Checkbox className="checkboxmargin" number={"18_months_" + index}  label="18 months" onChange={this.changeTenure.bind(this, index, 'M18')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M18'])} />
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <Checkbox className="checkboxmargin" number={"24_months_" + index}  label="24 months" onChange={this.changeTenure.bind(this, index, 'M24')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M24'])} />    
                        </div>
                    </div>
                <Label className="labela"> Brand Subvention </Label>
                <div className="row m-0 bottompaddingsubvention">
                    <div className=" col-xs-8 pr-0">
                        <Select name={"brandSubventionCol_" + index}
                        className="brandSubventionCol"
                        isClearable={false}
                        options={this.state.brandSubventionOptions}
                        defaultValue={this.state.brandSubventionOptions[0]}
                        placeholder="Percent"
                        onChange={this.updateBrandSubvention.bind(this, index)}
                        />
                    </div>
                    <div className=" col-xs-4 pl-0">
                        <Input id={"brand_value_" + index} className="form-control-subvention" value={this.state.brand_subvention_value[index]} onChange={(e)=> {
                        let {brand_value} = this.state;
                        brand_value = e.target.value;
                        if(((e.target.value)*1) < 0 || (e.target.value === '')){
                            this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                        }
                        this.setState({
                            brand_subvention_value: {...this.state.brand_subvention_value, [index]:brand_value},
                            mapField2: false
                        })
                    }}/>
                    </div>
                </div>

                <Label className="labela"> Maximum Cashback </Label>
                <div className="row m-0">
                    <div className=" col-xs-8 pl-0">
                        <Input id={"max_cashback_" + index} className="form-control-subvention" disabled={valuera} value={this.state.maximum_cashback[index]} onChange={(e)=> {
                            let {max_cashback} = this.state;
                            max_cashback = e.target.value;
                            if(((e.target.value)*1) < 0 || (e.target.value === '')){
                                this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                            }
                            this.setState({
                                maximum_cashback: {...this.state.maximum_cashback, [index]:max_cashback},
                                mapField2: false
                            })
                        }}/>
                    </div>
                </div>
                <div className="row m-0">
                    <Checkbox number={"isUpfront_" + index} label="Cashback is upfront?" onChange={this.changeisUpfrontstatus.bind(this, index)} checked={!!(this.state.isUpfront[index])} />
                </div>
                    </div>
                </div> 
            }    
        });

        let refine_disabler = false;
        if (this.state.selectedMerchantSubvention == "All_Level" || this.state.selectedMerchantSubvention == "State_Level"){
                refine_disabler = true;
        }
        else{
            refine_disabler = false;
        }

        let selected_merch_refine1 = () => {
            if (this.state.refineSearch == true){
                return this.state.selectedRefineSubvention;
            }
            else{
                return this.state.selectedMerchantSubvention;
            }
        }

        let selected_merch_refine = () => {
            if (this.state.refineSearch == true){
                return this.state.merchant_ida.label;
            }
            else{
                return this.state.selectedMerchValues[0];
            }
        }


        return( <div>
                    <div className="card-query-builder subvention-brand ">
                        <div className="col-md-12 pt-5">
                            <div className="card " ref={this.myRef}>
                                <div className="header">
                                    <h4 className="title">Campaign Description</h4>
                                </div>
                                <hr/>
                                <div className= "content">
                                    <div className="row bottompaddingsubvention">
                                        <div className=" col-sm-6 col-md-3 col-xs-12">
                                        <Label>Select start date</Label>
                                            <DatePicker
                                                dateFormat="dd-MM-yyyy"
                                                selected={Date.parse(this.state.startDate)}
                                                onChange={this.handleFromChange}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-md-3 col-xs-12">
                                        <Label>Select end date</Label>
                                            <DatePicker
                                                dateFormat="dd-MM-yyyy"
                                                selected={Date.parse(this.state.endDate)}
                                                onChange={this.handleToChange}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-md-3 col-xs-12">
                                        <Label>Maximum cashback allowed per card</Label>
                                        <Input id="txn_value" className="maxheighter" value={this.state.maxTxnAmount} onChange={(e)=> {
                                            let {maxTxnAmount1} = this.state;
                                            maxTxnAmount1 = e.target.value;
                                            if(((e.target.value)*1) <= 0 || (e.target.value === '')){
                                                this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                                            }
                                            this.setState({
                                                maxTxnAmount: maxTxnAmount1,
                                                mapField2: false
                                            })
                                        }}/>    
                                        </div>
                                    </div>  
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button onClick={this.openSectionToProduct.bind(this, true)} className="btn btn-primary">Goto Product Master</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Collapse isOpen={this.state.mapField0}>    
                        <div className="card-query-builder pt-5" >
                            <NotificationSystem ref="notificationSystem" style={style} />
                            <ReactTooltip />
                            <div className="col-md-12 pt-5">
                                <div className="card" ref={this.myRef2}>
                                    <div className="header">
                                        <h4 className="title">Product Master</h4>
                                    </div>
                                    <hr/>
                                    <Modal isOpen={this.state.newConfirmationModel} 
                                        toggle={this.toggleConfirmationModel.bind(this)} 
                                        size="lg"
                                        >
                                        <ModalBody>
                                            <div className="row">
                                                <div className="col-xs-12 ">
                                                    <h4 className="modalh4">Your Scheme</h4>
                                                    <hr/> 
                                                </div>
                                            </div>
                                            <div className="modalrow">
                                                    Duration:
                                                <div className="row">
                                                    <div className="col-xs-12 col-sm-6 col-md-2">
                                                        <Label>Start Date: </Label>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-6 col-md-2">
                                                        <Label>{start_date}</Label>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-xs-12 col-sm-6 col-md-2">
                                                        <Label>End Date: </Label>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-6 col-md-2">
                                                        <Label>{end_date}</Label>
                                                    </div>
                                                </div>   
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-6">
                                                    Maximum cashback allowed per card:  Rs.{max_txn}
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-6">
                                                    {selected_merch_refine1()}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-6">
                                                    {selected_merch_refine()}
                                                </div>
                                            </div>
                                            <hr/>
                                            {/*merch_selected_details()*/}
                                            <div className="modalrow">
                                                <h5 className="title">Subvention Details</h5>
                                                <div className="modalrow">
                                                    <div className="content table-responsive">
                                                        <table className="table table-striped table-hover" id="sku_showTable2">
                                                            <thead>
                                                                <tr>
                                                                    <th>Sr No.</th>
                                                                    <th>Bank</th>
                                                                    <th>EMI?</th>
                                                                    <th>Zero Cost?</th>
                                                                    <th>3 Month?</th>
                                                                    <th>6 Month?</th>
                                                                    <th>9 Month?</th>
                                                                    <th>12 Month?</th>
                                                                    <th>18 Month?</th>
                                                                    <th>24 Month?</th>
                                                                    <th>Brand Subvention</th>
                                                                    <th>Max Cashback</th>
                                                                    {/* <th>Bank Subvention</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {subvention_data}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className="modalrow">
                                                <h5 className="title">Your SKU List</h5>
                                                <div className="modalrow">
                                                    <div className="content table-responsive">
                                                        <table className="table table-striped table-hover" id="sku_showTable3" >
                                                            <thead>
                                                                <tr>
                                                                    <th>Sr No.</th>
                                                                    <th>Brand</th>
                                                                    <th>Category</th>
                                                                    <th>Level 1</th>
                                                                    <th>Level 2</th>
                                                                    <th>Level 3</th>
                                                                    <th>Level 4</th>
                                                                    <th>SKU</th>
                                                                    <th>Product Code</th>
                                                                    <th>MRP</th>
                                                                    <th>MOP</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {sku_selected}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="primary" onClick={this.sendCompleteScheme}>Confirm Campaign</Button>{' '}
                                            <Button color="secondary" onClick={this.toggleConfirmationModel.bind(this)}>Cancel</Button>
                                        </ModalFooter>
                                    </Modal>  
                                    <div className='sweet-loading'>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={20}
                                            color={'#123abc'}
                                            loading={this.state.loading}
                                        />
                                    </div>                          
                                    <div className="content table-full-width table-responsive">
                                        <div className="row m-0">
                                            <div className="col-md-12">
                                                <table className="table table-striped table-hover" id="sku_showTable">
                                                    <thead>
                                                        <tr>
                                                            <th>Sr No.</th>
                                                            <th>Brand</th>
                                                            <th>Category</th>
                                                            <th>Level 1</th>
                                                            <th>Level 2</th>
                                                            <th>Level 3</th>
                                                            <th>Level 4</th>
                                                            <th>SKU</th>
                                                            <th>Product Code</th>
                                                            <th>MRP</th>
                                                            <th>MOP</th>
                                                            <th>Applicable?</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {sku_show_data}
                                                    </tbody>
                                                </table>
                                            </div>
                                        <div className="col-md-12">
                                            <button onClick={this.openSectionToBanks.bind(this, true)} className="btn btn-primary">Goto Scheme Configuration</button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                    <Collapse isOpen={this.state.mapField2}>
                        <div className="card-query-builder subvention-brand ">
                            <div className="col-md-12 pt-5">
                                <div className="card p-t-5">
                                    <div className="header">
                                        <h4 className="title">Select Banks for Campaign</h4>
                                    </div>
                                    <hr/>
                                    <div className="content">
                                        <div className="rowbanks">
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="0" label="AMEX" onChange={this.changeActiver.bind(this, 0)} checked={!!(this.state.activer[0])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="1" label="Axis Bank" onChange={this.changeActiver.bind(this, 1)} checked={!!(this.state.activer[1])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="2" label="Citi Bank" onChange={this.changeActiver.bind(this, 2)} checked={!!(this.state.activer[2])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="3" label="HDFC Bank" onChange={this.changeActiver.bind(this, 3)} checked={!!(this.state.activer[3])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="4" label="HSBC Bank" onChange={this.changeActiver.bind(this, 4)} checked={!!(this.state.activer[4])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="5" label="ICICI Bank" onChange={this.changeActiver.bind(this, 5)} checked={!!(this.state.activer[5])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="6" label="IndusInd Bank" onChange={this.changeActiver.bind(this, 6)} checked={!!(this.state.activer[6])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="7" label="Kotak Bank" onChange={this.changeActiver.bind(this, 7)} checked={!!(this.state.activer[7])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="8" label="RBL" onChange={this.changeActiver.bind(this, 8)} checked={!!(this.state.activer[8])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="9" label="SBI" onChange={this.changeActiver.bind(this, 9)} checked={!!(this.state.activer[9])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="10" label="Standard Chartered" onChange={this.changeActiver.bind(this, 10)} checked={!!(this.state.activer[10])} />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <Checkbox  number="11" label="Yes Bank" onChange={this.changeActiver.bind(this, 11)} checked={!!(this.state.activer[11])} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6 col-xs-12">
                                                <button onClick={this.sendBankMappings.bind(this, true)} className="btn btn-primary">Next</button>
                                            </div>
                                        </div>  
                                    </div>
                                </div> 
                            </div>  
                        </div>
                    </Collapse>
                    <div>
                    <Collapse isOpen={this.state.mapField}>
                        <div className="card-query-builder subvention-brand ">
                            <div className="col-md-12 pt-5">
                                <div className="card " ref={this.myRef}>
                                    <div className="header">
                                        <h4 className="title">Scheme Master</h4>
                                    </div>
                                    <hr/>
                                    <div className= "content">
                                        <div className="mapField" >
                                            <div className="row bottompaddingsubvention">
                                            {/* {emi_displayer}    */}
                                            {bank_names}                 
                                            </div>
                                            <hr/>
                                            <div className="row bottompaddingsubvention">
                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                    <button onClick={this.sendEMIMappings.bind(this, true)} className="btn btn-primary btn-block buttonpaddingsubvention">Goto Merchant Master</button>
                                                </div>
                                            </div>
                                        </div>         
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                    <div>
                        <Collapse isOpen={this.state.mapField3}>
                            <div className="card-query-builder subvention-brand ">
                                <div className="col-md-12 pt-5">
                                    <div className="card " ref={this.myRef}>
                                        <div className="header">
                                            <h4 className="title">Merchant Master</h4>
                                        </div>
                                        <hr/>
                                        <div className= "content">
                                            <div className="mapField" >
                                                {refine_search()}
                                                <hr/>
                                                <div className="row bottompaddingsubvention">
                                                    <div className=" col-sm-6 col-md-3 col-xs-12">
                                                        <button onClick={this.merchantValidator.bind(this, true)} className="btn btn-primary btn-block buttonpaddingsubvention">Goto Campaign Confirmation</button>
                                                    </div>
                                                </div>
                                            </div>         
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>   
                    <div className="footer">
                        <div className="stats"><i></i></div>                        
                    </div>                   
                </div>
            </div>
        );
    }
}

export default Campaign;